import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Bearer fallback: cookies are primary, but if a token is stored (e.g. cookies
// blocked by the browser), attach it as Authorization for resilient auth.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vibeopps_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
